import { Directive, Input, ElementRef, HostBinding, } from '@angular/core';
import { Platform } from 'alyle-ui/core';
import { LySvgService } from './ly-svg.service';
var LySvgComponent = /** @class */ (function () {
    function LySvgComponent(svgService, _elementRef) {
        this.svgService = svgService;
        this._elementRef = _elementRef;
        this._size = '48px';
        this.styleWidth = '24px';
        this.styleHeight = '24px';
        this.prepend = true;
    }
    Object.defineProperty(LySvgComponent.prototype, "src", {
        get: function () {
            return this._src;
        },
        set: function (value) {
            if (!this._strEndsWith(value, '.svg')) {
                this._src = value + ".svg";
            }
            else {
                this._src = value;
            }
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(LySvgComponent.prototype, "size", {
        get: function () {
            return this._size;
        },
        set: function (val) {
            if (typeof val === 'number') {
                this._size = val + "px";
            }
            else {
                this._size = val;
            }
            this.updateSize();
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(LySvgComponent.prototype, "sizePx", {
        set: function (value) {
            if (value !== this._size) {
                this._size = value + "px";
                this.updateSize();
            }
        },
        enumerable: true,
        configurable: true
    });
    LySvgComponent.prototype.updateSize = function () {
        this.styleWidth = this.size;
        this.styleHeight = this.size;
    };
    LySvgComponent.prototype._strEndsWith = function (str, suffix) {
        return str.match(suffix + '$') == suffix;
    };
    LySvgComponent.prototype.ngOnInit = function () {
    };
    LySvgComponent.prototype.ngOnChanges = function (changes) {
        if (Platform.isBrowser) {
            if (changes['src']) {
                this._insertSVG();
            }
        }
    };
    LySvgComponent.prototype._insertSVG = function () {
        var _this = this;
        this.svgService.getSVG(this.src)
            .then(function (svg) {
            // console.log('suss src Insert SVG');
            // Insert SVG
            if (svg && _this._elementRef.nativeElement) {
                _this._elementRef.nativeElement.innerHTML = '';
                _this._insertElementSVG(svg);
            }
        }).catch(function (err) {
            console.warn('err', err);
        });
    };
    LySvgComponent.prototype._insertElementSVG = function (el) {
        if (this.prepend) {
            this._elementRef.nativeElement.insertBefore(el, this._elementRef.nativeElement.firstChild);
        }
        else {
            this._elementRef.nativeElement.appendChild(el);
        }
    };
    LySvgComponent.decorators = [
        { type: Directive, args: [{
                    selector: 'ly-svg, [ly-svg], [lySvg]'
                },] },
    ];
    /** @nocollapse */
    LySvgComponent.ctorParameters = function () { return [
        { type: LySvgService, },
        { type: ElementRef, },
    ]; };
    LySvgComponent.propDecorators = {
        "src": [{ type: Input, args: ['src',] },],
        "styleWidth": [{ type: HostBinding, args: ['style.width',] },],
        "styleHeight": [{ type: HostBinding, args: ['style.height',] },],
        "prepend": [{ type: Input },],
        "size": [{ type: Input, args: ['size',] },],
        "sizePx": [{ type: Input, args: ['size.px',] },],
    };
    return LySvgComponent;
}());
export { LySvgComponent };
//# sourceMappingURL=ly-svg.component.js.map